const zhCN = {
    'book': '预约',
    'booked': '已预约',
    'startSoon': '即将开始',
    'live': '观看',
    'ended': '已结束',
    'replay': '回看',
    'cancelled': '已取消',
    'bookedTips': '预约成功，您将收到开播提醒',
    'bookedErrorTips':'预约失败，请重试',
    'bookCancelTips': '预约已取消',
    'bookCancelErrorTips': '取消预约失败，请重试',
};

const zhHK = {
    'book': '預約',
    'booked': '已預約',
    'startSoon': '即將開始',
    'live': '觀看',
    'ended': '已結束',
    'replay': '回看',
    'cancelled': '已取消',
    'bookedTips': '預約成功，您將收到開播提醒',
    'bookedErrorTips': '預約失敗，請重試',
    'bookCancelTips': '預約已取消',
    'bookCancelErrorTips': '取消預約失敗，請重試',
};

const enUS = {
    'book': 'Book',
    'booked': 'Booked',
    'startSoon': 'Start soon',
    'live': 'Live',
    'ended': 'Ended',
    'replay': 'Replay',
    'cancelled': 'Cancelled',
    'bookedTips': 'Booked, You will receive a live reminder.',
    'bookedErrorTips': 'Failed to book. Please try again.',
    'bookCancelTips': 'Booking cancelled',
    'bookCancelErrorTips': 'Failed to cancel the booking. Please try again.',
};

const ja = {
    'book': '予約',
    'booked': '予約済み',
    'startSoon': 'まもなく',
    'live': 'ライブ',
    'ended': '終了',
    'replay': '再生',
    'cancelled': '取消済',
    'bookedTips': '予約完了、配信開始のアラートが届きます',
    'bookedErrorTips': '予約に失敗しました。再試行してください',
    'bookCancelTips': '取消済',
    'bookCancelErrorTips': 'キャンセルに失敗しました。再試行してください',
};

const lang = {
    0: zhCN,
    1: zhHK,
    2: enUS,
    5: ja,
};

export default lang;
